import zuleikaBanner from '../../../assets/images/personalized-invite/zuleika-banner.jpg';
import zuleikaLogo from '../../../assets/images/personalized-invite/zuleika-logo.png';

const ZULEIKA_OFFICE_CONDOMINIUM = 3086696;

const ZULEIKA_PERSONALIZED_INVITE = {
  customization: {
    primaryColor: '#4A2A72',
    secondaryColor: '#2A1842',
    logoUrl: zuleikaLogo,
    bannerImageUrl: zuleikaBanner,
    // Foto em retrato: na faixa baixa da capa, `top` corta o rosto
    bannerPosition: 'center 18%',
  },
  hostMessage:
    'Chegue com 10 minutos de antecedência e, se precisar remarcar, me avise pelo WhatsApp.',
  condominiumNotice:
    'o acesso é pelo portão de visitantes, na lateral do prédio, e você precisa levar um documento com foto.',
};

// Chave é o personContextId do condomínio, não o condominium.id
export const PERSONALIZED_INVITE_BY_CONDOMINIUM = {
  [ZULEIKA_OFFICE_CONDOMINIUM]: ZULEIKA_PERSONALIZED_INVITE,
};
